import React from 'react';
import { Chip } from '@mui/material';
import { getChipColor } from '@utils/get-chip-color';
import { GroupsEnum, PermissionEnum, StatusesEnum } from '@enums';
import { jsx as _jsx } from "react/jsx-runtime";
var groupOptions = [{
  label: GroupsEnum.Auditor,
  value: GroupsEnum.Auditor
}, {
  label: GroupsEnum.Registrar,
  value: GroupsEnum.Registrar
}, {
  label: GroupsEnum.Admin,
  value: GroupsEnum.Admin
}];
var permissionOptions = [{
  label: PermissionEnum.MANAGE_ADMIN_CONSOLE_USERS,
  value: PermissionEnum.MANAGE_ADMIN_CONSOLE_USERS
}, {
  label: PermissionEnum.MANAGE_WISPER_USERS,
  value: PermissionEnum.MANAGE_WISPER_USERS
}, {
  label: PermissionEnum.MANAGE_ADMIN_CONSOLE_GROUPS,
  value: PermissionEnum.MANAGE_ADMIN_CONSOLE_GROUPS
}, {
  label: PermissionEnum.READ_ONLY,
  value: PermissionEnum.READ_ONLY
}];
var statusOptions = [{
  label: /*#__PURE__*/_jsx(Chip, {
    label: StatusesEnum.New,
    color: getChipColor(StatusesEnum.New)
  }),
  value: StatusesEnum.New
}, {
  label: /*#__PURE__*/_jsx(Chip, {
    label: StatusesEnum.Active,
    color: getChipColor(StatusesEnum.Active)
  }),
  value: StatusesEnum.Active
}, {
  label: /*#__PURE__*/_jsx(Chip, {
    label: StatusesEnum.Block,
    color: getChipColor(StatusesEnum.Block)
  }),
  value: StatusesEnum.Block
}, {
  label: /*#__PURE__*/_jsx(Chip, {
    label: StatusesEnum.PinLocked.replaceAll('_', ' '),
    color: getChipColor(StatusesEnum.PinLocked)
  }),
  value: StatusesEnum.PinLocked
}];
export { groupOptions, permissionOptions, statusOptions };